'use strict';

import moment from 'moment';

class ProceduresController {
    /* @ngInject */
    constructor(
        ProceduresService,
        ClientsService,
        OrderTranslationService,
        StorageService,
        $scope,
        $q,
        FileSaver,
        Blob
    ) {
        Object.assign(this, {
            ProceduresService,
            ClientsService,
            OrderTranslationService,
            StorageService,
            $scope,
            $q,
            FileSaver,
            Blob
        });

        this.query = {
            include: ['client', {
                relation: 'collectionItems',
                scope: {
                    include: ['receipt', 'collection', 'paymentItems',
                              'bankTxes', 'checks']
                }
            }],
            where: {
            },
            order: 'date DESC',
            limit: 10,
            page: 1
        };

        // Restore saved search params
        this.mdOrder = this.StorageService.get('procedures.mdOrder');
        this.client = this.StorageService.get('procedures.client');
        this.from = this.StorageService.get('procedures.from');
        this.to = this.StorageService.get('procedures.to');

        this.getProcedures();

        this.onPagination = () => {
            this.getProcedures();
        };

        this.onReorder = () => {
            this.getProcedures();
        };
    }

    getProcedures() {
        // Order translation
        if (this.mdOrder) {
            this.StorageService.set('procedures.mdOrder', this.mdOrder);
            this.query.order = this.OrderTranslationService.translate(
                this.mdOrder
            );
        }

        // deep clone this.query
        let qOpts = JSON.parse(JSON.stringify(this.query));
        if (this.client) {
            this.StorageService.set('procedures.client', this.client);
            qOpts.where = Object.assign(qOpts.where, {
                clientId: this.client.id
            });
        }
        if (this.from) {
            this.StorageService.set('procedures.from', this.from);
            qOpts.where = Object.assign(qOpts.where, {
                date: {
                    gte: this.from
                }
            });
        }
        if (this.to) {
            this.StorageService.set('procedures.to', this.to);
            let dateTo = moment(this.to).endOf('day').toDate();
            if (this.from) {
                if (!qOpts.where.and) {
                    qOpts.where.and = [];
                }
                qOpts.where.and.push({
                    date: {
                        lte: dateTo
                    }
                });
                qOpts.where.and.push({
                    date: {
                        gte: this.from
                    }
                });
            } else {
                qOpts.where = Object.assign(qOpts.where, {
                    date: {
                        lte: dateTo
                    }
                }); 
            }
        }

        let queryReady = this.ProceduresService
            .getModels(qOpts)
            .then(procedures => {
                this.procedures = procedures;
            });
        let countReady = this.ProceduresService
            .getCount(qOpts)
            .then(result => {
                this.proceduresCount = result.count;
            });
        this.promise = this.$q.all([queryReady, countReady]);
        return this.promise;
    }

    querySearchClient() {
        return this.ClientsService.find({
            filter: {
                where: {
                    name: {
                        ilike: `%${this.searchTextClient}%`
                    }
                }
            }
        });
    }

    selectedClientChange(Client) {
        this.getProcedures();
    }

    download() {
        let qOpts = Object.assign({}, this.query);
        delete qOpts.limit;
        delete qOpts.where;

        this.showSpinner = true;
        this.ProceduresService
            .getModels(qOpts).then(procedures => {
                this.exportableItems = procedures;

                setTimeout(() => {
                    var blob = new this.Blob(
                        [document.getElementById('exportable').innerHTML], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                        });
                    this.FileSaver.saveAs(blob, "Reporte-tramites.xls");
                    this.showSpinner = false;
                    // Free DOM
                    this.exportableItems = null;
                }, 0);

            }).catch(() => {
                this.showSpinner = false;
            });

    }
}

export default ProceduresController;
